
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'DifferentialDiagnosisOfSpinalShockAndSpinalShock',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/DifferentialDiagnosisOfSpinalShockAndSpinalShock.vue